<template>
  <div
    class="flex flex-row items-center h-10 border-blue border-4 rounded-full mt-2"
  >
    <div class="flex flex-row items-center" @click="$emit('show', item)">
      <div style="margin: 10px 10px; margin-right: 4px;">
        <span v-if="isRejected()">
          <RejectedIcn width="20px" height="20px" />
        </span>
        <span v-else>
          <ApprovedIcn width="20px" height="20px" />
        </span>
      </div>
      <div style="width: 50px;" class="text-right mr-3">
        <span class="text-lg font-bold text-blue"
          >{{ index }}/{{ length }}</span
        >
      </div>
      <div class="mr-3" style="width: 130px;">
        <span class="text-lg text-blue">{{
          dayjs(item.receipt.expenseDate).format('YYYY/M/D')
        }}</span>
        <span class="text-sm text-blue">支出</span>
      </div>
      <div class="mr-3">
        <div v-if="item.type.length !== 0" class="flex flex-row items-center">
          <img :src="getIcon(item.type)" class="mr-1" width="20" height="20" />
          <!-- <span
            class="text-lg text-blue"
            style="width: 204px"
            v-if="item.type[0].id == 3"
            >{{ item.from }} ～ {{ item.to
            }}<span v-if="item.isRoundTrip">往復</span></span
          > -->
          <span class="text-lg text-blue" style="width: 204px"></span>
        </div>
        <div v-else class="flex flex-row items-center">
          <span class="text-blue mr-1" style="width: 224px">
            項目種別未選択
          </span>
        </div>
      </div>
      <div class="text-right mr-2" style="width: 105px;">
        <span class="text-lg text-blue" style="white-space: nowrap;">
          {{ makeAmountText(item.receipt) }}
        </span>
      </div>
    </div>
    <div style="margin-left: auto !important; width: 80px">
      <button
        class="rounded-full border-4 border-blue h-10"
        style="width: 80px; border-right: none;"
        type="button"
        @click="$emit('remove', item)"
      >
        <div class="flex flex-row items-center">
          <span class="text-blue font-bold ml-3 mr-1">消去</span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="11"
              fill="white"
              stroke="#2993CE"
              stroke-width="2"
            />
            <path
              d="M17.7071 7.70711C18.0976 7.31658 18.0976 6.68342 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.2929C7.31658 5.90238 6.68342 5.90238 6.29289 6.2929C5.90237 6.68343 5.90237 7.31659 6.29289 7.70711L10.5858 12L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711Z"
              fill="#2993CE"
            />
          </svg>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import ApprovedIcn from '@/assets/icons/approved-blue.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useMemoryItems } from '@/services/politicalActionToda/useMemoryItems'

export default {
  name: 'MemoryFormItem_TODA',

  components: {
    ApprovedIcn,
    RejectedIcn,
  },

  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    index: Number,
    length: Number,
  },

  setup(props) {
    const { memoryItemTypes, getIcon } = useMemoryItems()
    const { currentPoliticalAction } = usePoliticalActions()

    const makeAmountText = receipt => {
      const amount = receipt?.expenseAmount ?? 0
      const numerator = receipt?.numerator
      const denominator = receipt?.denominator
      const partialAmount = receipt?.partialAmount ?? 0
      if (receipt?.isPartial && partialAmount !== 0) {
        return `${partialAmount.toLocaleString()}円`
      } else if (
        !receipt?.isDistributed ||
        !numerator ||
        !denominator ||
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator < 1 ||
        denominator < 1
      ) {
        return `${amount.toLocaleString()}円`
      }

      const proratedAmount = prorate(amount, numerator, denominator)
      return `${proratedAmount.toLocaleString()}円`
    }
    /**
     * 按分する
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     * @returns number
     */
    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator).toLocaleString()
    }

    // 差し戻しコメントが1件でもある場合trueを返却する
    const isRejected = () => {
      const sentBackItems = currentPoliticalAction.memory.sentBackItems
      if (sentBackItems.length === 0) {
        return false
      } else {
        return (
          sentBackItems[0]?.items.filter(el => el.target.includes(props.index))
            .length !== 0
        )
      }
    }

    return { memoryItemTypes, getIcon, makeAmountText, isRejected }
  },
}
</script>
